export default __webpack_public_path__ + "static/media/player_2_2.ad872bb3.png";